import { render } from "./header.vue?vue&type=template&id=f867ac30&scoped=true&lang=pug"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=f867ac30&lang=scss&scoped=true"
import "./header.vue?vue&type=style&index=1&id=f867ac30&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f867ac30"]])

export default __exports__